import { gql } from '@apollo/client';
export const UpdateSubTypeIsRestrictedMutation = gql `
    mutation UpdateSubTypeIsRestricted($siteSetId: InstitutionSetId!, $subTypeIsRestricted: Boolean!) {
        staffhours {
            settings {
                updateSubTypeIsRestricted(siteSetId: $siteSetId, subTypeIsRestricted: $subTypeIsRestricted)
            }
        }
    }
`;
